var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-table", {
        ref: "table",
        attrs: { pagination: _vm.pagination },
        on: { onPageChange: _vm.handlePageChange },
        scopedSlots: _vm._u([
          {
            key: "thead",
            fn: function() {
              return [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.headColumns, function(col, colIndex) {
                      return _c("th", { key: colIndex, style: col.style }, [
                        _c(
                          "span",
                          [
                            colIndex === 0
                              ? [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(col.text) +
                                      "\n              "
                                  )
                                ]
                              : _c(
                                  "base-sort-label",
                                  {
                                    on: {
                                      onChange: function($event) {
                                        return _vm.handleSortChange(
                                          $event,
                                          _vm.mapKey[colIndex]
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.sort[_vm.mapKey[colIndex]],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.sort,
                                          _vm.mapKey[colIndex],
                                          $$v
                                        )
                                      },
                                      expression: "sort[mapKey[colIndex]]"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(col.text) +
                                        "\n              "
                                    )
                                  ]
                                )
                          ],
                          2
                        )
                      ])
                    }),
                    0
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "tbody",
            fn: function() {
              return [
                _c(
                  "tbody",
                  [
                    _vm.empty
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "6" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.notfounddata")) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.rows, function(row, rowIndex) {
                      return _c(
                        "tr",
                        {
                          key: rowIndex,
                          on: {
                            click: function($event) {
                              return _vm.onClick($event, rowIndex)
                            }
                          }
                        },
                        _vm._l(6, function(col, colIndex) {
                          return _c("td", { key: colIndex }, [
                            _c(
                              "div",
                              {
                                staticClass: "sku",
                                style: [{ cursor: "pointer" }],
                                attrs: { "data-sku-id": row.sku_id },
                                on: {
                                  mouseover: function($event) {
                                    return _vm.onMouseover(
                                      $event,
                                      rowIndex,
                                      0,
                                      ".sku",
                                      "#f9f9f9"
                                    )
                                  },
                                  mouseleave: function($event) {
                                    return _vm.onMouseleave(
                                      $event,
                                      rowIndex,
                                      0,
                                      ".sku"
                                    )
                                  }
                                }
                              },
                              [
                                colIndex === 0
                                  ? _c("span", [
                                      _c("i", {
                                        class: [
                                          "fas fa-angle-right",
                                          {
                                            active:
                                              _vm.stateUIRows[rowIndex]
                                                .showSkuId === row.sku_id
                                          }
                                        ]
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.getProductFullName(
                                              row.product_name,
                                              row.sku.attributes
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : _c("span", [
                                      _c("u", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.setToCustomDigitsNumberWithCheckEmpty(
                                              row[_vm.mapKey[colIndex]]
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                _vm._v(" "),
                                _vm._l(row.warehouses, function(wh, whIndex) {
                                  return _vm.stateUIRows[rowIndex].showSkuId ===
                                    row.sku_id
                                    ? _c(
                                        "div",
                                        {
                                          key: whIndex,
                                          staticClass: "warehouse",
                                          style: [
                                            {
                                              cursor: wh.bins.length
                                                ? "pointer"
                                                : "default"
                                            }
                                          ],
                                          attrs: { "data-wh-id": wh.wh_id },
                                          on: {
                                            mouseover: function($event) {
                                              return _vm.onMouseover(
                                                $event,
                                                rowIndex,
                                                whIndex,
                                                ".warehouse",
                                                "#f2f2f2"
                                              )
                                            },
                                            mouseleave: function($event) {
                                              return _vm.onMouseleave(
                                                $event,
                                                rowIndex,
                                                whIndex,
                                                ".warehouse"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          colIndex === 0
                                            ? _c("span", [
                                                _c("i", {
                                                  class: [
                                                    "fas fa-angle-right",
                                                    {
                                                      active:
                                                        _vm.stateUIRows[
                                                          rowIndex
                                                        ].showWhId === wh.wh_id
                                                    }
                                                  ],
                                                  style: [
                                                    {
                                                      opacity: wh.bins.length
                                                        ? 1
                                                        : 0
                                                    }
                                                  ]
                                                }),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(wh.short_name) +
                                                    "\n                "
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.setToCustomDigitsNumberWithCheckEmpty(
                                                        wh[_vm.mapKey[colIndex]]
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                          _vm._v(" "),
                                          _vm._l(wh.bins, function(
                                            bin,
                                            binIndex
                                          ) {
                                            return _vm.stateUIRows[rowIndex]
                                              .showWhId === wh.wh_id
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: binIndex,
                                                    staticClass: "bin",
                                                    style: [
                                                      {
                                                        cursor:
                                                          bin.lots.length ||
                                                          bin.serials.length
                                                            ? "pointer"
                                                            : "default"
                                                      }
                                                    ],
                                                    attrs: {
                                                      "data-bin-id":
                                                        bin.bin_location_id ||
                                                        "null"
                                                    },
                                                    on: {
                                                      mouseover: function(
                                                        $event
                                                      ) {
                                                        return _vm.onMouseover(
                                                          $event,
                                                          rowIndex,
                                                          binIndex,
                                                          ".bin",
                                                          "#e8e8e8"
                                                        )
                                                      },
                                                      mouseleave: function(
                                                        $event
                                                      ) {
                                                        return _vm.onMouseleave(
                                                          $event,
                                                          rowIndex,
                                                          binIndex,
                                                          ".bin"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    colIndex === 0
                                                      ? _c("span", [
                                                          _c("i", {
                                                            class: [
                                                              "fas fa-angle-right",
                                                              {
                                                                active:
                                                                  _vm
                                                                    .stateUIRows[
                                                                    rowIndex
                                                                  ]
                                                                    .showBinId ===
                                                                  (bin.bin_location_id ||
                                                                    "null")
                                                              }
                                                            ],
                                                            style: [
                                                              {
                                                                opacity:
                                                                  bin.lots
                                                                    .length ||
                                                                  bin.serials
                                                                    .length
                                                                    ? 1
                                                                    : 0
                                                              }
                                                            ]
                                                          }),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                bin.code ||
                                                                  _vm.$t(
                                                                    "apps.inventory.message.notspecified"
                                                                  )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.setToCustomDigitsNumberWithCheckEmpty(
                                                                  bin[
                                                                    _vm.mapKey[
                                                                      colIndex
                                                                    ]
                                                                  ]
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]),
                                                    _vm._v(" "),
                                                    _vm._l(bin.lots, function(
                                                      lot,
                                                      lotIndex
                                                    ) {
                                                      return _vm.stateUIRows[
                                                        rowIndex
                                                      ].showBinId ===
                                                        (bin.bin_location_id ||
                                                          "null")
                                                        ? _c(
                                                            "div",
                                                            {
                                                              key: lotIndex,
                                                              staticClass:
                                                                "lot",
                                                              style: [
                                                                {
                                                                  cursor:
                                                                    "default"
                                                                }
                                                              ],
                                                              on: {
                                                                mouseover: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onMouseover(
                                                                    $event,
                                                                    rowIndex,
                                                                    lotIndex,
                                                                    ".lot",
                                                                    "#dedede"
                                                                  )
                                                                },
                                                                mouseleave: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onMouseleave(
                                                                    $event,
                                                                    rowIndex,
                                                                    lotIndex,
                                                                    ".lot"
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              colIndex === 0
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                      " +
                                                                        _vm._s(
                                                                          lot.lot_code
                                                                        ) +
                                                                        "\n                    "
                                                                    )
                                                                  ])
                                                                : _c(
                                                                    "span",
                                                                    [
                                                                      colIndex ===
                                                                      3
                                                                        ? [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  _vm.setToCustomDigitsNumberWithCheckEmpty(
                                                                                    lot.reserved_count
                                                                                  )
                                                                                ) +
                                                                                "\n                      "
                                                                            )
                                                                          ]
                                                                        : colIndex ===
                                                                          5
                                                                        ? [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  _vm.setToCustomDigitsNumberWithCheckEmpty(
                                                                                    lot.unit_balance
                                                                                  )
                                                                                ) +
                                                                                "/" +
                                                                                _vm._s(
                                                                                  _vm.setToCustomDigitsNumberWithCheckEmpty(
                                                                                    lot.unit_init
                                                                                  )
                                                                                ) +
                                                                                "\n                      "
                                                                            )
                                                                          ]
                                                                        : _vm._e()
                                                                    ],
                                                                    2
                                                                  )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      bin.serials,
                                                      function(ser, serIndex) {
                                                        return _vm.stateUIRows[
                                                          rowIndex
                                                        ].showBinId ===
                                                          (bin.bin_location_id ||
                                                            "null")
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: serIndex,
                                                                staticClass:
                                                                  "serial",
                                                                style: [
                                                                  {
                                                                    cursor:
                                                                      "default"
                                                                  }
                                                                ],
                                                                on: {
                                                                  mouseover: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onMouseover(
                                                                      $event,
                                                                      rowIndex,
                                                                      serIndex,
                                                                      ".serial",
                                                                      "#dedede"
                                                                    )
                                                                  },
                                                                  mouseleave: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onMouseleave(
                                                                      $event,
                                                                      rowIndex,
                                                                      serIndex,
                                                                      ".serial"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                colIndex === 0
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "\n                      " +
                                                                          _vm._s(
                                                                            ser.ser_code
                                                                          ) +
                                                                          "\n                    "
                                                                      )
                                                                    ])
                                                                  : _c(
                                                                      "span",
                                                                      [
                                                                        colIndex ===
                                                                        5
                                                                          ? [
                                                                              _vm._v(
                                                                                "\n                        " +
                                                                                  _vm._s(
                                                                                    _vm.setToCustomDigitsNumberWithCheckEmpty(
                                                                                      ser.unit_balance
                                                                                    )
                                                                                  ) +
                                                                                  "\n                      "
                                                                              )
                                                                            ]
                                                                          : _vm._e()
                                                                      ],
                                                                      2
                                                                    )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ])
                        }),
                        0
                      )
                    })
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66a6fe36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a6fe36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseTableSkuLevel.vue
// module id = null
// module chunks = 